<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'元旦快乐-帮助页'"></div>

    <div>元旦快乐-帮助页</div>

  </div>
</template>
<script>
export default {
  name: 'LaborDay',
  components: {},
  data () {
    return {};
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {}
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/newYearDay/help/index.vue